import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';
import MDButton from 'components/MDButton';
import CrudService from 'services/cruds-service';
import { toast } from 'react-toastify';
import { TagsInput } from 'react-tag-input-component';

const AddItem = ({ onNewItemSubmit }) => {
  const [formData, setFormData] = useState({
    value: '',
    attachment: null,
    imagePreview: null,
    tags: []
  });
  const [selected, setSelected] = useState([]);
  const [isLoading, setisLoading] = useState(false)

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setFormData({
          ...formData,
          attachment: file,
          imagePreview: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.value || !formData.attachment) {
      toast.info('Please fill in all fields and upload an image.');
      return;
    }

    try {
      // Create a FormData object
      const data = new FormData();
      data.append('value', formData.value);
      data.append('attachment', formData.attachment);
      selected.forEach((tag, index) => {
        data.append(`tags[${index}]`, tag);
      })

      // Send the data to the API
      setisLoading(true)
      const response = await CrudService.createStorageList(data);
      setisLoading(false)
      if (!response.status) {
        throw new Error('Failed to upload data');
      }
      toast.success('Item uploaded successfully')
      onNewItemSubmit()
    } catch (error) {
      console.error('Error uploading data:', error);
      toast.error(`${error.message}`)
    } finally {
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: 300 }}
    >
      <Typography variant="h6">Add New Item</Typography>

      {/* Name Input */}
      <TextField
        label="Name"
        name="value"
        value={formData.value}
        onChange={handleInputChange}
        variant="outlined"
      />

      {/* tags Input */}
      <TagsInput
        value={selected}
        onChange={setSelected}
        name="Tags"
        placeHolder="tags"
        style={{ fontSize: '14px', fontWeight: 300 }}
      />

      {/* Image Input */}
      <MDButton
        variant="contained"
        component="label"
        sx={{ textTransform: 'none' }}
      >
        Upload Image
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={handleFileChange}
        />
      </MDButton>
      <p style={{ color: 'red', fontSize: '11px', margin: 0, padding: 0, position: 'relative', top: '-10px' }}> Max. 10mb image can be uploaded* </p>

      {/* Display Selected Image Name */}
      {formData.imagePreview && (
        <Box
          component="img"
          src={formData.imagePreview}
          alt="Selected"
          sx={{ width: '100%', maxWidth: 200, borderRadius: 1, mt: 2 }}
        />
      )}

      {/* Submit Button */}
      {
        isLoading ?
          <MDButton disabled >
            <CircularProgress size="25px" />
          </MDButton> :
          <MDButton type="submit" variant="contained" color="primary">
            Submit
          </MDButton>
      }
    </Box>
  );
};

export default AddItem;
